import { Card } from '@mui/material'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import React from 'react'
import TabsHeader from './components/TabsHeader'
import Agency from './components/Agency'
import Location from './components/Location'
const NavigationCustomiztion = ({ data, handleChange }) => {


  
  return (
    <Card id="navigation-customiztion" sx={{ overflow: 'visible' }}>
      <MDBox p={3}>
        <MDTypography variant="h5">Navigation Customization</MDTypography>
      </MDBox>
      <MDBox component="form" pb={3} px={3}>
        {data?.agency_type == true && data?.sub_account_type == true ? (
          <TabsHeader
            elements={[
              <Agency data={data} handleChange={handleChange} />,
              <Location data={data} handleChange={handleChange} />,
            ]}
          />
        ) : data?.agency_type == true ? (
          <div>
            {' '}
            <Agency data={data} handleChange={handleChange} />
          </div>
        ) : data?.sub_account_type == true ? (
          <div>
            {' '}
            <Location data={data} handleChange={handleChange} />
          </div>
        ) : (
          <></>
        )}
      </MDBox>
    </Card>
  )
}

export default NavigationCustomiztion
